import React from "react";
import Card from "components/card";
import { 
    LuStar,
} from "react-icons/lu"
import RecognitionCard from "./RecognitionCard";

const RecognitionWall = () => {
    return (
        <Card className="flex flex-col gap-6 rounded-2xl border border-purple-200">
            <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 [.border-b]:pb-6">
                <h4 className="leading-none flex items-center gap-2">
                    <LuStar className="w-5 h-5 text-amber-600" />
                    Recognition Wall
                </h4>
                <p className="text-slate-700">
                    Team recognition and shoutouts
                </p>
            </div>
            <div className="px-6 pb-6">
                <div className="space-y-4">
                    <RecognitionCard 
                        employee="Sarah Chen"
                        description="Great work on the Q3 presentation! Your insights were invaluable."
                        date="2 days ago"
                    />
                    <RecognitionCard 
                        employee="Marcus Johnson"
                        description="Thanks for helping me debug that issue. You're a lifesaver!"
                        date="5 days ago"
                    />
                    <RecognitionCard 
                        employee="Emily Rodriguez"
                        description="Outstanding performance this quarter. Keep up the excellent work!"
                        date="1 week ago"
                    />
                </div>
            </div>
        </Card>
    )
};
export default RecognitionWall;